import { useState } from 'react';

export const useToggle = <T>(values: T[]) => {
  const [value, setValue] = useState(values[0]);
  const index = values.indexOf(value);
  const next = () => setValue(values[(index + 1) % values.length]);
  return [value, next] as const;
};
